import React from 'react';
import { BLOCKER_LABELS, BLOCKER_TYPES } from '../../platform/store/useOperationalStore';
import { activeEstimate } from '../../platform/engine/estimateMoney';
import { fmtAgo } from './roHelpers';
import { buildApprovalSmsHref } from './roMoney';

// Prominent, full-width banner for the active blocker. Its button resolves
// the specific thing the job is waiting on — it does not change the
// underlying blocker logic (still cleared via BlockerPanel's Resolve button).
export default function BlockerBanner({ truck, currentBlocker, now, onOpenEstimate, onViewParts }) {
  if (!currentBlocker) return null;

  function handleResolveClick() {
    if (currentBlocker.type === BLOCKER_TYPES.WAITING_PARTS) {
      onViewParts();
      return;
    }
    if (currentBlocker.type === BLOCKER_TYPES.WAITING_AUTHORIZATION) {
      const href = buildApprovalSmsHref(truck, activeEstimate(truck));
      if (href) { window.location.href = href; return; }
      onOpenEstimate();
    }
  }

  const resolveLabel =
    currentBlocker.type === BLOCKER_TYPES.WAITING_PARTS         ? 'View Parts ETA' :
    currentBlocker.type === BLOCKER_TYPES.WAITING_AUTHORIZATION ? 'Resend Approval Text' :
    null;

  return (
    <div className="ro-blocker-banner">
      <span className="ro-blocker-banner-icon">⛔</span>
      <div className="ro-blocker-banner-body">
        <div className="ro-blocker-banner-title">
          {BLOCKER_LABELS[currentBlocker.type] || currentBlocker.type}
          {currentBlocker.description && <span className="ro-blocker-banner-desc"> — {currentBlocker.description}</span>}
        </div>
        <div className="ro-blocker-banner-meta">
          Blocked {fmtAgo(currentBlocker.setAt, now)} ago
          {currentBlocker.setBy && ` · set by ${currentBlocker.setBy}`}
          {currentBlocker.owner && ` · owner: ${currentBlocker.owner}`}
        </div>
      </div>
      {resolveLabel && (
        <button className="ro-blocker-banner-btn" onClick={handleResolveClick}>{resolveLabel}</button>
      )}
    </div>
  );
}
